import React, { useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import {
  FilterGroup,
  MultipleChoiceFilter,
  FilterWithPreset,
} from '@lt/components';

const MultichoiceFilterGroup = ({
  data,
  isMobile,
  onChange,
  onClear,
  Filter,
  LabelComponent,
  visibleItems,
  expandLabel,
  presets,
  className,
  isCollapsible = false,
  mobileCheckboxFloat,
  customCheckboxStyles = '',
  isClearButtonInline = false,
  currencyCode,
}) => {
  const { filterName, filterLabel } = Filter;
  const handleChange = useCallback(
    (diff) => onChange({ path: filterName, diff }),
    [filterName, onChange],
  );

  const handleClear = useCallback(
    () => onClear(filterName),
    [filterName, onClear],
  );

  const FilterComponent = presets ? FilterWithPreset : MultipleChoiceFilter;

  return (
    <FilterGroup
      className={className}
      label={filterLabel}
      onClear={handleClear}
      showClearBtn={data.some((item) => item.selected)}
      isMobile={isMobile}
      isCollapsible={isCollapsible}
      isClearButtonInline={isClearButtonInline}
    >
      <FilterComponent
        {...(presets ? { presets } : {})}
        items={data}
        className={`filter-${filterName}`}
        onChange={handleChange}
        visibleItems={visibleItems}
        LabelComponent={LabelComponent}
        expandLabel={expandLabel}
        isMobile={isMobile}
        mobileCheckboxFloat={mobileCheckboxFloat}
        customCheckboxStyles={customCheckboxStyles}
        currencyCode={currencyCode}
      />
    </FilterGroup>
  );
};

MultichoiceFilterGroup.defaultProps = {
  className: '',
  LabelComponent: undefined,
  visibleItems: undefined,
  presets: undefined,
  expandLabel: undefined,
  isMobile: false,
  mobileCheckboxFloat: undefined,
};

MultichoiceFilterGroup.propTypes = {
  className: PropTypes.string,
  data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  onChange: PropTypes.func.isRequired,
  onClear: PropTypes.func.isRequired,
  Filter: PropTypes.shape({
    filterName: PropTypes.string,
    filterLabel: PropTypes.string,
  }).isRequired,
  LabelComponent: PropTypes.node,
  visibleItems: PropTypes.number,
  presets: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      field: PropTypes.string.isRequired,
    }),
  ),
  expandLabel: PropTypes.string,
  isMobile: PropTypes.bool,
  mobileCheckboxFloat: PropTypes.string,
  currencyCode: PropTypes.string,
};

export default memo(MultichoiceFilterGroup);
